import angular from 'angular';
import uiRouter from 'angular-ui-router';
import popUpComponent from './pop-up.component';
import popUpListComponent from './pop-up-list.component';
import popUpDetailComponent from './pop-up-detail.component';
import PopUpService from './pop-up.service';
import NotificationService from '../notification/notification.service'

let popUpModule = angular.module('popUp', [
  uiRouter
])
.service('PopUp', PopUpService)
.service('NotificationService', NotificationService)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/pop-up');

  $stateProvider
    .state('pop-up', {
      component: 'popUp'
    })
    .state('pop-up.list', {
      url: '/pop-up',
      component: 'popUpList'
    })
    .state('pop-up.create', {
      url: '/pop-up/new',
      component: 'popUpDetail',
    })
    .state('pop-up.detail', {
      url: '/pop-up/:id/detail',
      component: 'popUpDetail',
      params: {
        id: ""
      }
    })
})
.component('popUp', popUpComponent)
.component('popUpList', popUpListComponent)
.component('popUpDetail', popUpDetailComponent)
.name;

export default popUpModule;



// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up.js